import { useMutation } from '@tanstack/react-query';
import ObrasApi from 'Data/Obras.api';
import toastHandler from 'Utils/toastHandler';
import { FILES_QUERY_KEY, QUERY_KEY_MOVE_FILES_LIST } from 'Data/keys/QueryKeys';
import { IUseQueryFilesReturn } from 'Data/interfaces/ListagemArquivos/IListFiles';
import { IFileRenameData } from 'Data/interfaces/ListagemArquivos/IFileRenameRequest';
import { ListagemArquivosActions } from 'Store/ListagemArquivos/ListagemArquivos.actions';
import { useDispatch, useSelector } from 'react-redux';
import { IFileData } from 'Data/interfaces/ListagemArquivos/IListFilesResponse';
import { getSelectedEditRowKeys } from 'Store/ListagemArquivos/ListagemArquivos.selector';
import { queryClient } from 'Context/QueryClientContext';

export const useQueryRenameFiles = () => {
  const dispatch = useDispatch();
  const selectedEditRowKeys = useSelector(getSelectedEditRowKeys);

  const { mutate, mutateAsync, isPending } = useMutation({
    mutationFn: (variables: IFileRenameData) => {
      return ObrasApi.renameFile(variables);
    },
    onSuccess: async ({ data }, variables) => {
      await Promise.all([
      await queryClient.cancelQueries({
        queryKey: [
          FILES_QUERY_KEY,
          Number(variables.ConstructionSiteId),
          variables.FolderId,
        ],
        exact: true,
      }),
      await queryClient.cancelQueries({
        queryKey: [
          QUERY_KEY_MOVE_FILES_LIST,
          Number(variables.ConstructionSiteId),
          variables.FolderId,
        ],
        exact: true,
      }),
      ]);

      queryClient.setQueryData<IUseQueryFilesReturn>(
        [FILES_QUERY_KEY, Number(variables.ConstructionSiteId), variables.FolderId],
        (old) => {
          if (old) {
            const index = old.ListFiles.findIndex((file) => {
              return file.Identifier.ApiId === data.data.FileApiId;
            });
            const indexExistName = old.ListFiles.findIndex((file) => {
              return (
                file.NameWithoutRevision === data.data.NameWithoutRevision &&
                file.Identifier.ApiId !== data.data.FileApiId
              );
            });
            if (index !== -1) {
              old.ListFiles[index].Name = data.data.Name;
              old.ListFiles[index].NameWithoutRevision = data.data.NameWithoutRevision;
              old.ListFiles[index].HasInconsistencia = false;
              old.ListFiles[index].Revision = data.data.Revision;
              old.ListFiles[index].RevisionNumber = data.data.RevisionNumber;

              if (old.ListFiles[index].Versions !== null) {
                if (indexExistName !== -1) {
                  let newFile = {} as IFileData;
                  let fileUpdateIndex: number;
                  let fileRemoveIndex: number;
                  let fileRemoveKey: string;

                  if (
                    old.ListFiles[indexExistName].RevisionNumber >
                    data.data.RevisionNumber
                  ) {
                    old.ListFiles[indexExistName].Versions?.push({
                      ...old.ListFiles[indexExistName],
                      Identifier: {
                        ...old.ListFiles[indexExistName].Identifier,
                        ApiId: data.data.FileApiId,
                      },
                      Name: data.data.Name,
                      Revision: data.data.Revision,
                      NameWithoutRevision: data.data.NameWithoutRevision,
                      RevisionNumber: data.data.RevisionNumber,
                    });
                    newFile = old.ListFiles[indexExistName];
                    fileRemoveIndex = index;
                    fileUpdateIndex = indexExistName;
                  } else {
                    const newVersions = old.ListFiles[indexExistName].Versions ?? [];
                    newVersions.push(old.ListFiles[indexExistName]);
                    newFile.Versions = newVersions;
                    fileUpdateIndex = index;
                    fileRemoveIndex = indexExistName;
                    fileRemoveKey = old.ListFiles[indexExistName].Identifier.ApiId;
                  }

                  old.ListFiles.splice(fileUpdateIndex, 1, newFile);
                  old.ListFiles.splice(fileRemoveIndex, 1);

                  dispatch(
                    ListagemArquivosActions.setSelectedEditRowKeys(
                      selectedEditRowKeys.filter((row) => row !== fileRemoveKey),
                    ),
                  );
                }
              }
            }
            return { ...old };
          }
          return old;
        },
      );
      queryClient.setQueryData<IUseQueryFilesReturn>(
        [
          QUERY_KEY_MOVE_FILES_LIST,
          Number(variables.ConstructionSiteId),
          variables.FolderId,
        ],
        (old) => {
          if (old) {
            const index = old.ListFiles.findIndex((file) => {
              return file.Identifier.ApiId === data.data.FileApiId;
            });
            const indexExistName = old.ListFiles.findIndex((file) => {
              return (
                file.NameWithoutRevision === data.data.NameWithoutRevision &&
                file.Identifier.ApiId !== data.data.FileApiId
              );
            });
            if (index !== -1) {
              old.ListFiles[index].Name = data.data.Name;
              old.ListFiles[index].NameWithoutRevision = data.data.NameWithoutRevision;
              old.ListFiles[index].HasInconsistencia = false;
              old.ListFiles[index].Revision = data.data.Revision;
              old.ListFiles[index].RevisionNumber = data.data.RevisionNumber;

              if (old.ListFiles[index].Versions !== null) {
                if (indexExistName !== -1) {
                  let newFile = {} as IFileData;
                  let fileUpdateIndex: number;
                  let fileRemoveIndex: number;
                  let fileRemoveKey: string;

                  if (
                    old.ListFiles[indexExistName].RevisionNumber >
                    data.data.RevisionNumber
                  ) {
                    old.ListFiles[indexExistName].Versions?.push({
                      ...old.ListFiles[indexExistName],
                      Identifier: {
                        ...old.ListFiles[indexExistName].Identifier,
                        ApiId: data.data.FileApiId,
                      },
                      Name: data.data.Name,
                      Revision: data.data.Revision,
                      NameWithoutRevision: data.data.NameWithoutRevision,
                      RevisionNumber: data.data.RevisionNumber,
                    });
                    newFile = old.ListFiles[indexExistName];
                    fileRemoveIndex = index;
                    fileUpdateIndex = indexExistName;
                  } else {
                    const newVersions = old.ListFiles[indexExistName].Versions ?? [];
                    newVersions.push(old.ListFiles[indexExistName]);
                    newFile.Versions = newVersions;
                    fileUpdateIndex = index;
                    fileRemoveIndex = indexExistName;
                    fileRemoveKey = old.ListFiles[indexExistName].Identifier.ApiId;
                  }

                  old.ListFiles.splice(fileUpdateIndex, 1, newFile);
                  old.ListFiles.splice(fileRemoveIndex, 1);

                  dispatch(
                    ListagemArquivosActions.setSelectedEditRowKeys(
                      selectedEditRowKeys.filter((row) => row !== fileRemoveKey),
                    ),
                  );
                }
              }
            }
            return { ...old };
          }
          return old;
        },
      );

      toastHandler.showSuccess(
        variables.IsFolder
          ? 'Pasta atualizada com sucesso!'
          : 'Arquivo atualizado com sucesso!',
      );
      dispatch(ListagemArquivosActions.setShowModalCreateFolder(false));
    },
    onError: async (error: any, variables) => {
      const msg = variables.IsFolder
        ? 'Erro ao renomear pasta'
        : 'Erro ao renomear arquivo';
      const errorMsg = error.errors ? error.errors[0]?.Message || msg : msg;
      toastHandler.showError(errorMsg);
      dispatch(ListagemArquivosActions.setShowModalCreateFolder(false));
    },
  });

  return {
    renameFiles: mutate,
    renameFilesAsync: mutateAsync,
    isLoading: isPending,
  };
};
